import React, { useState } from "react";
import { FiSearch, FiPhoneCall, FiMail, FiClock } from "react-icons/fi";
import { FaWhatsapp } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import AllResponse from "./components/AllResponse";
import AllRespond from "./components/AllRespond";
import { listPageStatusChange } from "../../redux/property/PropertySlice";
import AllListing from "./components/AllListing";
import "./components/DashboardListingsNew.css";

const AllResponseListing = () => {
  const { listpageStatus } = useSelector((store) => store.Property);
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState("");

  const renderSwitch = (param) => {
    switch (param) {
      case 0:
        return <AllResponse searchTerm={searchTerm} />;
      case 1:
        return <AllResponse searchTerm={searchTerm} />;
      case 2:
        return <AllRespond searchTerm={searchTerm} />;
      default:
        return <AllListing />;
    }
  };

  return (
    <div className="mgh-dl-container">
      {/* ================= Modern Filter & Search Bar ================= */}
      <div className="component__pageFilters_allistings">
        <div className="activationStatus">
          <label>Inquiry Status</label>
          <ol className="component__filterList">
            <li
              className={listpageStatus === 0 ? "component__activefilter" : ""}
              onClick={() => dispatch(listPageStatusChange(0))}
            >
              All Inquiries
            </li>
            <li
              className={listpageStatus === 1 ? "component__activefilter" : ""}
              onClick={() => dispatch(listPageStatusChange(1))}
            >
              Contact Views
            </li>
            <li
              className={listpageStatus === 2 ? "component__activefilter" : ""}
              onClick={() => dispatch(listPageStatusChange(2))}
            >
              Direct Responses
            </li>
          </ol>
        </div>

        <div className="localityFilterMy99">
          <div className="search-my">
            <FiSearch size={16} color="#64748b" />
            <input
              type="text"
              placeholder="Search by buyer, phone or property..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>
      </div>

      {/* ================= Main View Component ================= */}
      {renderSwitch(listpageStatus)}

      {/* ================= Modern Seller Support Section ================= */}
      <div className="mgh-support-card">
        <div className="mgh-support-head">
          <h4>
            <FiPhoneCall color="#ea580c" />
            <span>Need Help with Buyer Inquiries & Leads?</span>
          </h4>
        </div>

        <div className="mgh-support-grid">
          <div className="mgh-support-item">
            <div className="mgh-support-icon">
              <FiPhoneCall />
            </div>
            <div className="mgh-support-info">
              <span>Seller Helpline</span>
              <a href="tel:+919063483711">+91 90634 83711</a>
            </div>
          </div>

          <div className="mgh-support-item">
            <div className="mgh-support-icon">
              <FaWhatsapp />
            </div>
            <div className="mgh-support-info">
              <span>WhatsApp Support</span>
              <a
                href="https://wa.me/919063483711?text=Hello%20MyGoldenHomes%20support"
                target="_blank"
                rel="noopener noreferrer"
              >
                +91 90634 83711
              </a>
            </div>
          </div>

          <div className="mgh-support-item">
            <div className="mgh-support-icon">
              <FiMail />
            </div>
            <div className="mgh-support-info">
              <span>Email Support</span>
              <a href="mailto:services@ewrealty.com">
                services@ewrealty.com
              </a>
            </div>
          </div>

          <div className="mgh-support-item">
            <div className="mgh-support-icon">
              <FiClock />
            </div>
            <div className="mgh-support-info">
              <span>Support Timings</span>
              <strong>Mon - Sat (9 AM - 7 PM)</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllResponseListing;
